export default __webpack_public_path__ + "static/media/image_audit_logo.73068081.png";